import React from 'react';
import moment from 'moment';
import WarningIcon from 'zignal-landscape/lib/Icon/WarningIcon';
import Save2Icon from 'zignal-landscape/lib/Icon/Save2Icon';
import Remove2Icon from 'zignal-landscape/lib/Icon/Remove2Icon';

export const getClassNameBasedOnCoverage = (isValid, isCovered) => {
  if (!isValid) {
    return 'invalidStory';
  }
  return isCovered ? 'coveredStory' : 'uncoveredStory';
};

export const getIconBasedOnCoverage = (isValid, isCovered) => {
  if (!isValid) {
    return <WarningIcon />;
  }
  return isCovered ? <Save2Icon /> : <Remove2Icon />;
};

export const getCommaSeparatedStringOrNone = (sourceArray) => {
  return sourceArray.length > 0 ? sourceArray.join(', ') : 'None';
};

export const getPrettyfiedStatistics = (storyCount, lastCoveredAt) => {
  if (storyCount > 0) {
    return `
        In the last 24 months, we have covered <b>${storyCount} stories</b> from this source,
        an average of ${(storyCount/(24 * 30)).toFixed(1)} stories a day.
        This source was last covered on <b>${moment(lastCoveredAt).format('M/D/YY')}</b>`;
  }
  return '';
};
